import React from "react";
import { Check } from "lucide-react";

/**
 * DependsOnMultiSelect (SOUND-506) — the acyclicity-guaranteeing control.
 * Offers ONLY the steps that appear ABOVE this one (`earlierSteps`), as toggle
 * chips. Selecting writes step identities (`_id`), so a dependency can only ever
 * be "runs after an earlier step" — a forward/cyclic edge is structurally
 * unexpressible. Deps are keyed by `_id` (not raw key) so they survive renames.
 */
export default function DependsOnMultiSelect({ earlierSteps = [], selectedIds = [], onChange }) {
  if (earlierSteps.length === 0) {
    return <span className="text-xs text-muted-foreground">No earlier steps — runs immediately.</span>;
  }

  const toggle = (id) =>
    onChange(selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);

  return (
    <div className="flex flex-wrap gap-1.5">
      {earlierSteps.map((s) => {
        const on = selectedIds.includes(s._id);
        return (
          <button
            key={s._id}
            type="button"
            onClick={() => toggle(s._id)}
            aria-pressed={on}
            className={`badge cursor-pointer ${on ? "badge-brand" : "badge-muted"}`}
            title={s.title || s.key}
          >
            {on ? (
              <Check className="h-3 w-3" />
            ) : (
              <span className="h-3 w-3 rounded-[3px] border border-current opacity-50" />
            )}
            <span className="max-w-[160px] truncate">
              #{s.index + 1} · {s.title || s.key || "step"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
